import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import EmailsVue from "../../../core/components/email/AGGridEmailDisplay.vue";
// import { computed } from 'vue';
import { useStore } from 'vuex';

import { createConnection } from '../../../core/signalr/clients/EmailDataHub';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const { myHub } = createConnection('http://localhost:4446', "EmailDataHub")

console.log(myHub);

myHub?.on('update', (p: any) => {

    store.dispatch('addEmail', p);

})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(EmailsVue, { Emails: _ctx.emails }, null, 8, ["Emails"])
  ]))
}
}

})